import { render, staticRenderFns } from "./vitalBig2.vue?vue&type=template&id=521be38c&scoped=true&"
import script from "./vitalBig2.vue?vue&type=script&lang=js&"
export * from "./vitalBig2.vue?vue&type=script&lang=js&"
import style0 from "./vitalBig2.vue?vue&type=style&index=0&id=521be38c&scoped=true&lang=css&"
import style1 from "./vitalBig2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521be38c",
  null
  
)

export default component.exports